import KhmerSecondarySchedule from '@/api/khmer-secondary-schedule'
import AcademicYear from '@/api/academic-year'
import ProgramMain from '@/api/main-program'
import ProgramSub from '@/api/sub-program'
import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState,
  found_data: {},
  academicYears: [],
  programMains: [],
  programSubs: [],
  weekDays: [],
  schedules: {},
  subjects: {}
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  SET_FOUND_DATA(state, data) {
    state.found_data = data
  },
  RECEIVE_ACADEMIC_YEARS(state, data) {
    state.academicYears = data
  },
  RECEIVE_ACADEMIC_PROGRAM_MAINS(state, data) {
    state.programMains = data
  },
  RECEIVE_ACADEMIC_PROGRAM_SUBS(state, data) {
    state.programSubs = data
  },
  SET_WEEKDAYS(state, data) {
    state.weekDays = data
  },
  SET_SUBJECT(state, data) {
    state.subjects = data
  },
  SET_SCHEDULE(state, data) {
    state.schedules = data
  }
}

export const actions = {
  fetch(context, attrubutes = {}) {
    let params = attrubutes
    return KhmerSecondarySchedule.get({ params }).then(response => {
      if (response.schedule) {
        context.commit('SET_SCHEDULE', response.schedule)
        context.commit('SET_SUBJECT', response.subject)
      }
      return Promise.resolve(response)
    })
  },
  generate(context, data) {
    return KhmerSecondarySchedule.store(data)
  },
  updateSchedule(context, { stp_id, ...data }) {
    return KhmerSecondarySchedule.update(stp_id, data.data)
  },
  destroy(context, id) {
    return KhmerSecondarySchedule.destroy(id)
  },
  generateToSchedule(context, data) {
    return KhmerSecondarySchedule.generateToSchedule(data)
  },
  exportExcel(context, attributes) {
    return KhmerSecondarySchedule.exportExcel(attributes)
  },
  previewSchedule(context, data) {
    return KhmerSecondarySchedule.previewSchedulePdf(data)
  },
  fetchAcademicYear(context, attributes = {}) {
    return AcademicYear.get({
      headers: {
        'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
      },
      params: {
        page: -1,
        fields: {
          academic_years: 'ac_year_id,ac_year'
        },
        ...attributes
      }
    }).then(response => {
      context.commit('RECEIVE_ACADEMIC_YEARS', response.data)
      return Promise.resolve(response)
    })
  },
  fetchProgramMain(context, attributes = {}) {
    return ProgramMain.get({
      headers: {
        'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
      },
      params: {
        page: -1,
        fields: {
          academic_program_mains: 'acp_id,acp_name_native,acp_name_foreign'
        },
        ...attributes
      }
    }).then(response => {
      context.commit('RECEIVE_ACADEMIC_PROGRAM_MAINS', response.data)
      return Promise.resolve(response)
    })
  },
  fetchProgramSub(context, attributes = {}) {
    return ProgramSub.get({
      headers: {
        'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
      },
      params: {
        page: -1,
        fields: {
          academic_program_subs: 'acps_id,acps_name_native,acps_name_foreign'
        },
        filter: {
          acp_id: attributes.acp_id
        },
        ...attributes
      }
    }).then(response => {
      context.commit('RECEIVE_ACADEMIC_PROGRAM_SUBS', response.data)
      return Promise.resolve(response)
    })
  },
  async dataBeforeCreate(context) {
    if (!context.state.weekDays.length > 0) {
      let response = await KhmerSecondarySchedule.getWeekdays()
      context.commit('SET_WEEKDAYS', response.data)
    }
  }
}
